module.exports = __webpack_public_path__ + "img/register-bg.c8e4a7b3.png";